<template>
  <div>
    <form @submit.prevent="search()" class="enroll-student md-layout">
      <div class="md-layout-item md-size-15">
        <md-field>
          <label>{{ $t("common.grade") }}</label>
          <md-select name="grade" id="grade" v-model="formSearch.grade">
            <md-option value="">{{ $t("common.all") }}</md-option>
            <md-option
              v-for="grade in gradeOptions"
              :value="grade.name"
              :key="grade.id + grade.name"
            >
              {{ $t(grade.name) }}
            </md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-20">
        <md-field>
          <label>{{ $t("common.full_name") }}</label>
          <md-input v-model.trim="formSearch.full_name"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-35">
        <md-field>
          <label>{{ $t("class.filter_id_enroll") }}</label>
          <md-input v-model.trim="formSearch.student_ids"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-30">
        <md-field>
          <label>{{ $t("class.filter_term_enroll") }}</label>
          <md-select
            name="term_never_assigned"
            id="term_never_assigned"
            v-model="formSearch.term_never_assigned"
          >
            <md-option value="All term">
              {{ $t("class.all_term") }}
            </md-option>
            <md-option value="Term of this class">
              {{ $t("class.term_of_this_class") }}
            </md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-100 text-center">
        <md-button type="submit" class="md-info mr-6">
          {{ $t("common.search") }}
        </md-button>
      </div>
    </form>
    <div class="md-layout">
      <div class="md-layout-item md-size-100" v-if="tableData.length">
        <yv-table
          :tableData="tableData"
          :pagination="pagination"
          :columns="columns"
          selectable="multiple"
          :hideAction="true"
          :hideBulkAction="true"
          :sort-data="sortData"
          :selectedItems="selectedItems"
          @selectItems="onSelectItems"
          @changePage="changePage"
          ref="studentSelectionsRef"
        />
        <yv-pagination
          :pagination="pagination"
          @changePage="changePage"
          class="my-4"
        />
      </div>
      <div class="md-layout-item md-size-100 my-8" v-else>
        <no-data-found></no-data-found>
      </div>
    </div>
  </div>
</template>
<script>
import { YvTable, YvPagination } from "@/components/Base";
import { service_paths } from "@/constants/Services";
import NoDataFound from "@/components/Base/Illustration/NoDataFound";

export default {
  name: "student-selections",
  components: { NoDataFound, YvPagination, YvTable },
  props: ["studentData"],
  data() {
    const defaultPage = 1;
    const defaultLimit = 10;
    const classId = this.$route.params.id;
    return {
      path: `${service_paths.classes}/${classId}/assignable-students`,
      formSearch: {
        grade: "",
        full_name: null,
        student_ids: null,
        term_never_assigned: null
      },
      gradeOptions: [],
      tableData: [],
      selectedItems: [],
      columns: {
        avatar_url: "class.student_col_avatar",
        student_code: "common.student_code",
        username: "common.username",
        full_name: "class.student_col_fullname",
        grade: "common.grade",
        sex: "class.student_col_sex",
        warning: "class.student_col_warning"
      },
      pagination: {
        perPage: defaultLimit,
        from: 0,
        to: 0,
        total: 0,
        currentPage: defaultPage,
        hidePaging: false,
        hidePerPageOptions: false
      },
      paramsPagination: {
        page: defaultPage,
        limit: defaultLimit
      },
      sortData: {
        currentSort: "_id",
        currentSortOrder: "desc"
      }
    };
  },
  methods: {
    fetchGradesList() {
      this.$axios.get(service_paths.grades, { limit: 20 }).then(resp => {
        if (resp) {
          resp.data.data.map(el => {
            this.gradeOptions.push({
              id: el.name,
              name: el.name
            });
          });
        }
      });
    },

    onSelectItems(items) {
      this.selectedItems = items;
    },

    getSelected() {
      return this.$refs.studentSelectionsRef.selectedItems.map(e => e.username);
    },

    search() {
      let studentCode = [];
      if (this.formSearch.student_ids) {
        studentCode = this.formSearch.student_ids
          .split(",")
          .map(el => el.trim());
      }

      const params = {
        grade: this.formSearch.grade,
        ["full_name__~"]: this.formSearch.full_name,
        student_ids: studentCode,
        term_never_assigned: this.formSearch.term_never_assigned,
        ...this.paramsPagination
      };

      this.$axios.get(this.path, params).then(response => {
        this.tableData = this.formatTableData(response.data.data);
        this.updatePaginationParams(response.data);
      });
    },

    updatePaginationParams(response) {
      this.pagination.total = response.total;
      this.pagination.from = response.from;
      this.pagination.to = response.to;
    },

    formatTableData(tableData) {
      return tableData.map((studentData, index) => {
        studentData.noNumb = index;
        const numb = Math.random().toFixed(2) * 100000;
        const avatar_url =
          studentData.avatar_url ||
          `https://picsum.photos/50/50?random=${numb}`;
        studentData.avatar_url = `<img src="${avatar_url}" class="object-cover rounded-full w-[42px] h-[42px]">`;
        studentData.warning = studentData.warning || "";
        return studentData;
      });
    },

    changePage() {
      this.paramsPagination.page = this.pagination.currentPage;
      this.paramsPagination.limit = this.pagination.perPage;
      this.search();
    }
  },
  created() {
    this.fetchGradesList();
    this.search();
  }
};
</script>
<style lang="scss" scoped>
.enroll-student label {
  font-size: 14px;
}
</style>
